import { useState } from 'react'
import { renderToString } from 'react-dom/server'
import { useAddPopupMessage } from './useAddPopupMessage'
import SensorLabel from '../../components/icons/sensor-label'

export const useGatewayLabel = () => {
  const [generatingLabel, setGeneratingLabel] = useState(false)
  const addMessage = useAddPopupMessage()

  const saveFile = (file: Blob, filename: string) => {
    const url = URL.createObjectURL(file)

    const downloadLink = document.createElement('a')
    downloadLink.href = url
    downloadLink.download = filename

    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
    URL.revokeObjectURL(url)
  }

  const saveSvg = (svgData: string, filename: string) => {
    const preface = '<?xml version="1.0" standalone="no"?>\r\n'
    const svgBlob = new Blob([preface, svgData], {
      type: 'image/svg+xml;charset=utf-8'
    })
    saveFile(svgBlob, filename)
  }

  const downloadLabel = async (deviceId: string) => {
    setGeneratingLabel(true)
    try {
      const svgData = renderToString(<SensorLabel deviceId={deviceId} />)
      saveSvg(svgData, `${deviceId}.svg`)
    } catch (err) {
      addMessage({ type: 'error', text: (err as Error).message })
    } finally {
      setGeneratingLabel(false)
    }
  }

  return {
    generatingLabel,
    downloadLabel
  }
}
